'use client';

import { ROUTES } from '@shared/constants';
import { ErrorContent, ErrorContentProps } from '@/components/ErrorContent';
import { useFirebase } from '@/providers/firebase';
export const NotFoundContent = ({
  imageSrc,
  imageAlt,
  imageClass,
  title,
  subtitle
}: ErrorContentProps) => {
  const {
    user
  } = useFirebase();
  return <ErrorContent imageSrc={imageSrc} imageAlt={imageAlt} imageClass={imageClass} buttonLabel="Go back" buttonLink={user ? ROUTES.HOME : ROUTES.SIGN_IN} title={title} subtitle={subtitle} className="py-10 md:py-16" data-sentry-element="ErrorContent" data-sentry-component="NotFoundContent" data-sentry-source-file="index.tsx" />;
};